/* eslint-disable no-unused-vars */
import Vue from 'vue'
import api from '../../services/serveice'
import $ from 'jquery'
import { BCarousel } from 'bootstrap-vue'
Vue.component('b-carousel', BCarousel)
var moment = require('moment')
export default {
  name: 'main',
  data() {
    return {
      date_now: new Date(),
      videoId: 'tiiFjXql6zI',
      title_que: '',
      playerVars: {
        autoplay: 1
      },
      text_show: 'บ้านและครอบครัวที่อบอุ่น คือรากฐานที่สำคัญของสังคม นพดลพานิชจึงสนับสนุนให้เพื่อนร่วมงานทุกคนยึดถือหลักในการทำงานเพื่อ “สร้างรากฐานให้ชีวิต” สร้างโอกาสที่ดีกว่าเดิมให้กับคนรุ่นหลัง',
      que_list: [
        {
          'que_id': 1,
          'cust_name': 'คุณทดสอบ เทสเสมอนะ',
          'pick_name': 'รับของ/ส่งออก',
          'status': 2
        },
        {
          'que_id': 2,
          'cust_name': 'คุณทดสอบ เทสเสมอนะ',
          'pick_name': 'รับของ/ส่งออก',
          'status': 1
        },
        {
          'que_id': 3,
          'cust_name': 'คุณทดสอบ เทสเสมอนะ',
          'pick_name': 'รับของ/ส่งออก',
          'status': 0
        }
      ],
      img_list: [
        {'url': 'https://firebasestorage.googleapis.com/v0/b/perfect-ce95d.appspot.com/o/StData%2FNopadol1.jpg?alt=media&token=27847be3-66b5-4f19-a8e7-9ea2eb5fcd38'},
        {'url': 'https://firebasestorage.googleapis.com/v0/b/perfect-ce95d.appspot.com/o/StData%2FNopadol13.jpg?alt=media&token=085dbb25-32c5-4e16-bb5e-10ebeec053c2'},
        {'url': 'https://firebasestorage.googleapis.com/v0/b/perfect-ce95d.appspot.com/o/StData%2FNopadol16.jpg?alt=media&token=6fd51bc0-8c2c-44c8-9e77-187261577ac6'},
        {'url': 'https://firebasestorage.googleapis.com/v0/b/perfect-ce95d.appspot.com/o/StData%2FNopadol28.jpg?alt=media&token=3bba2e2c-f48f-4006-8620-96036553292d'},
        {'url': 'https://firebasestorage.googleapis.com/v0/b/perfect-ce95d.appspot.com/o/StData%2FNopadol2.jpg?alt=media&token=2dd5cabf-c602-455a-9764-7538c518762f'},
        {'url': 'https://firebasestorage.googleapis.com/v0/b/perfect-ce95d.appspot.com/o/StData%2FNopadol40.jpg?alt=media&token=601676ca-6366-4291-807b-16feca53c432'}
      ],
      que_mock: [
        // {
        //   'id': [1,2,3],
        //   'wh_code': 'S1-B',
        //   'cust_name': 'test1 yooooooo',
        //   'status': 1,
        //   'time_stamp': new Date()
        // },
        // {
        //   'id': [4,5,6],
        //   'wh_code': 'B1-D',
        //   'cust_name': 'test2 yeasss',
        //   'status': 2,
        //   'time_stamp': new Date()
        // },
        // {
        //   'id': [7,8,9],
        //   'wh_code': 'S2-3',
        //   'cust_name': 'test2 yeasss',
        //   'status': 0,
        //   'time_stamp': new Date()
        // }
      ],
      readyvdo: false,
      autoFade: null,
      auto_pulling: null,
      auto_time: null,
      config: {
        company_id: 1,
        branch_id: 1,
        zone: 1,
        show_type: 1
      },
      teplist: []
    };
  },
  computed: {
    player() {
      return this.$refs.youtube.player;
    }
  },
  methods: {
    playing() {
      console.log("play");
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
    ready(event) {
      this.player.playVideo();
      // console.log("ready", event);
    },
    ended(event) {
      this.player.playVideo();
      // console.log("ended", event);
    },
    playVideo() {
      this.player.playVideo();
    },
    checkPickTime(time) {
      let now =  new Date()
      console.log(moment(time).format('mm'), moment(now).format('mm'))
      if (moment(now).format('mm') > moment(time).format('mm')) {
        return 'quadrat'
      }
    },
    getDataQue() {
      let playload = {
        "company_id": this.config.company_id,
        "branch_id": this.config.branch_id
      }
      api.getQueList(
        playload,
        result => {
          if (result.response === 'success') {
            this.getQue()
            setTimeout(() => {
              if (this.que_list.lenght != 0) {
                this.autoFadeout()
              }
              this.autoPulling()
            }, 500);
          } else {
            // alert('ดึงข้อมูล QueList ไม่สำเร็จ :' + result.message)
            console.log(result)
          }
        },
        error => {
          console.log(JSON.stringify(error))
          // alert('ดึงข้อมูลคิวไม่สำเร็จ', JSON.stringify(error))
        }
      )
    },
    diff_minutes(dt2, dt1) {
      var diff =(dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    },
    getQue() {
      let playload = {
        "company_id": this.config.company_id,
        "branch_id": this.config.branch_id
      }
      api.getQueList(
        playload,
        result => {
          if (result.response === 'success') {
            // let dt1 = new Date();
            let mock = []
            this.que_mock = []
            this.que_list = []
            mock = result.data
            mock.forEach(val => {
              var index = this.que_mock.findIndex(x => x.wh_code === val.wh_code && x.cust_code === val.cust_code)
              if (index < 0) {
                let tempinput = {
                  'que_id': [val.que_id],
                  'wh_code': val.wh_code,
                  'cust_name': val.cust_name,
                  'cust_code': val.cust_code,
                  'start_time': val.start_time,
                  'status': val.status,
                  'time_stamp': val.time_stamp,
                  'status_desc': val.status_desc
                }
                // let dt2 = new Date(val.start_time)
                // let timelap = (this.diff_minutes(dt1, dt2))
                // if (timelap > 15 && val.status != 2) {
                //   tempinput.status = -1
                // }
                if (val.pick_time > 15 && val.status != 2) {
                  tempinput.status = 99
                }
                this.que_mock.push(tempinput)
              } else {
                // console.log('dupicat')
                this.que_mock[index].que_id.push(val.que_id)
                switch (val.status) {
                  case val.status == 1:
                    this.que_mock[index].status = val.status
                    break;
                  case val.status <= this.que_mock[index].status:
                    this.que_mock[index].status = val.status
                    break;
                  default: this.que_mock[index].status = val.status
                    break;
                }
                if (val.pick_time > 15 && val.status != 2) {
                  this.que_mock[index].status = 99
                }
              }
            })
            // console.log(this.que_mock)
            this.teplist = this.que_mock
            this.que_list = this.que_mock
          } else {
            // alert('ดึงข้อมูล QueList ไม่สำเร็จ :' + result.message)
            console.log(result)
          }
        },
        error => {
          console.log(JSON.stringify(error))
          // alert('ดึงข้อมูลคิวไม่สำเร็จ', JSON.stringify(error))
        }
      )
    },
    autoFadeout () {
      $.fn.infiniteScrollUp=function(){
        var i = 0
        var self=this,kids=self.children()
        kids.slice(kids.length).hide()
        this.autoFade = setInterval(function(){
          // console.log(kids.length)
          if (kids.length > 4) {
            kids.slice( 0, 4 ).fadeOut(function(){
              // $(this).appendTo(self)
              // kids=self.children()
              // console.log(self)
            })
            i = i+4
            // console.log(i)
            if (i >= kids.length) {
              i = 0
              setTimeout(() => {
                kids.fadeIn()
              }, 2000);
            } 
          } else {
            kids.fadeIn()
          }
        }, 10000)
        return this
      }
      $(function(){
        $('tbody').infiniteScrollUp()
      })
    },
    autoPulling () {
      this.auto_pulling = setInterval(() => {
        this.getQue()
      }, 14000);
    },
    goSetting(){
      this.$router.push({ name: "Setting" });
    },
    timeUpdate () {
      this.auto_time = setInterval(() => {
        this.date_now = new Date()
      }, 1000)
    }
  },
  created() {
    this.config = JSON.parse(localStorage.que_config)
    console.log("branch", this.config.branch_id)
  },
  mounted() {
    this.getDataQue()
    let outer = document.querySelector("#outer");
    let content = outer.querySelector("#content");

    repeatContent(content, outer.offsetWidth);

    let el = outer.querySelector("#loop");
    el.innerHTML = el.innerHTML + el.innerHTML;

    function repeatContent(el, till) {
      let html = el.innerHTML;
      let counter = 0; // prevents infinite loop

      while (el.offsetWidth < till && counter < 100) {
        el.innerHTML += html;
        counter += 1;
      }
    }
    // this.autoFadeout()
    this.timeUpdate()
  },
  destroyed() {
    clearInterval(this.autoFade)
    clearInterval(this.auto_pulling)
    clearInterval(this.auto_time)
  },
}